import React from 'react';

const AboutUs: React.FC = () => {
    return (
        <><div style={{ padding: "2rem", maxWidth: 1200, margin: "0 auto" }}>
            <h2 style={{ fontSize: "1.9rem", marginBottom: "2rem" }}>About Us</h2>

            {/* First Part - About Us with Manish's Photo */}
            <div style={{
                display: 'flex',
                gap: '2rem',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                marginBottom: "3rem",
                paddingBottom: "3rem",
                borderBottom: "2px solid #e0e0e0"
            }}>
                {/* Text Section */}
                <div style={{ flex: 1, minWidth: 320, fontSize: "0.9rem", lineHeight: 1.6 }}>
                    <p>
                        <strong>Algebracorp OPC Private Limited</strong> is an AI-first technology company committed to building one of the world's most comprehensive digital ecosystems. Our focus is to engineer intelligent, scalable, and future-ready solutions powered by advanced artificial intelligence, automation, and deep technological innovation.
                    </p>
                    <p>
                        At the center of Algebracorp's vision is the creation of a seamlessly connected universe where social platforms, healthcare systems, entertainment networks, financial tools, digital commerce, and cloud services work as one unified ecosystem—intelligently driven by our proprietary AI engine, DeepMatrix.
                    </p>
                    <h3 style={{ marginTop: "2rem", fontSize: "1.05rem" }}>Leadership — Manish Srivastava, Founder, MD & CEO</h3>
                    <p>
                        Algebracorp is founded and led by <strong>Manish Srivastava</strong>, an accomplished Finance & Treasury Professional with 21 years of cross-sector experience, including 18 years in the GCC region. His professional journey spans diverse industries such as Jewelry, IT trading, Oil & Gas, and large-scale corporate operations.
                    </p>
                    <strong style={{ fontSize: "0.92rem" }}>Manish's Expertise Includes:</strong>
                    <ul style={{ fontSize: "0.88rem", lineHeight: 1.7 }}>
                        <li>Treasury setup & management</li>
                        <li>Cash and liquidity management</li>
                        <li>Financial planning & analysis</li>
                        <li>Risk, FX, and trade finance</li>
                        <li>Team leadership and organizational development</li>
                        <li>Corporate governance, reporting, and strategic decision support</li>
                    </ul>
                    <p>
                        Manish successfully built and led a treasury function from the ground up, managing a team of 12 professionals across treasury and accounting. His expertise in systems, process control, financial architecture, and organizational development forms the foundation of Algebracorp's operational discipline.
                    </p>
                    <p>
                        In 2019, he received the Best Performance Award at Qatar Fuel Co. (Woqod) for his exceptional leadership, innovation, and contribution to financial systems.
                    </p>
                    <h3 style={{ fontSize: "1.05rem" }}>A Visionary Turning Technology Into Impact</h3>
                    <p>
                        Drawing upon his deep analytical abilities and strategic thinking, Manish established Algebracorp with a vision to create India's most powerful AI-driven technology stack—including:
                    </p>
                    <ul style={{ fontSize: "0.88rem", lineHeight: 1.7 }}>
                        <li>A social ecosystem with global scalability</li>
                        <li>AI engines capable of multi-domain operations</li>
                        <li>Healthcare innovation through Conveyr Health</li>
                        <li>Future planning in EVs, hydrogen tech, robotics, and semiconductors</li>
                        <li>AI models for stock market prediction and financial automation</li>
                        <li>Advanced bleeding control products for defense & healthcare</li>
                        <li>Next-gen autonomous robots with multi-tasking AI</li>
                    </ul>
                    <p>
                        His ambition is to build not just products, but a self-sustaining AI-powered world capable of enhancing human potential and creating real-world impact across industries.
                    </p>
                    <p>
                        Under his leadership, Algebracorp continues to grow as a dynamic, innovation-driven, and purpose-led tech organization.
                    </p>
                    <h3 style={{ fontSize: "1.05rem" }}>Our Identity</h3>
                    <p>
                        At Algebracorp, we believe that AI should not be a feature—<br />
                        it should be the foundation of tomorrow's digital life.<br />
                        This belief fuels our work as we build Conveyr and the larger ecosystem around it. Our team is united by a shared vision: to develop intelligent systems that make life simpler, smarter, and more connected.<br />
                        Together, we are building a future where technology elevates human capability across communication, healthcare, business, creativity, entertainment, and everyday living.
                    </p>
                </div>
                {/* Manish Srivastava's Picture Section */}
                <div style={{ flex: '0 0 280px', textAlign: 'center', marginLeft: "auto" }}>
                    <img
                        src={require('../assets/Manish.png')}
                        alt="Manish Srivastava - Founder"
                        style={{
                            width: "220px",
                            height: "auto",
                            borderRadius: "13px",
                            marginBottom: "1rem",
                            boxShadow: "0 4px 12px rgba(164,0,0,0.10)"
                        }} />
                    <div style={{ fontWeight: "bold", marginTop: "0.5rem", color: "#A40000", fontSize: "0.95rem" }}>
                        Manish Srivastava<br />Founder, MD & CEO
                    </div>
                </div>
            </div>

            {/* Second Part - Vision and Mission Side by Side */}
            <div style={{
                display: 'flex',
                gap: '3rem',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                marginTop: "2rem"
            }}>
                {/* Vision Section */}
                <div style={{
                    flex: '1 1 45%',
                    minWidth: 300,
                    padding: "2rem",
                    background: "linear-gradient(135deg, rgba(123,31,162,0.05) 0%, rgba(123,31,162,0.02) 100%)",
                    borderRadius: "15px",
                    border: "1px solid rgba(123,31,162,0.1)"
                }}>
                    <h3 style={{ fontSize: "1.4rem", color: "#7b1fa2", marginBottom: "1.5rem", fontWeight: "bold" }}>
                        Vision Statement
                    </h3>
                    <p style={{ fontSize: "0.9rem", lineHeight: 1.65 }}>
                        Our vision is to position India as a global force in AI technology and digital ecosystems by developing world-class, sovereign platforms that protect national interests and empower every user.
                    </p>
                    <p style={{ fontSize: "0.9rem", lineHeight: 1.65, marginTop: "1rem", fontWeight: "500" }}>
                        We envision an India where:
                    </p>
                    <ul style={{ fontSize: "0.87rem", lineHeight: 1.7 }}>
                        <li>Data belongs to the people and the nation.</li>
                        <li>AI is developed ethically, responsibly, and within India's borders.</li>
                        <li>Communication, commerce, healthcare, entertainment, and social networks operate on Indian-built digital infrastructure.</li>
                        <li>Innovation fuels economic strength and technological autonomy.</li>
                    </ul>
                    <p style={{ fontSize: "0.9rem", lineHeight: 1.65, marginTop: "1rem" }}>
                        Algebracorp aspires to build an ecosystem that reflects India's values, safeguards citizen rights, and establishes a future where the nation is not dependent on imported digital technologies.
                    </p>
                </div>

                {/* Mission Section */}
                <div style={{
                    flex: '1 1 45%',
                    minWidth: 300,
                    padding: "2rem",
                    background: "linear-gradient(135deg, rgba(164,0,0,0.05) 0%, rgba(164,0,0,0.02) 100%)",
                    borderRadius: "15px",
                    border: "1px solid rgba(164,0,0,0.1)"
                }}>
                    <h3 style={{ fontSize: "1.4rem", color: "#A40000", marginBottom: "1.5rem", fontWeight: "bold" }}>
                        Mission Statement
                    </h3>
                    <p style={{ fontSize: "0.9rem", lineHeight: 1.65 }}>
                        Our mission is to build a secure, intelligent, and sovereign digital ecosystem that strengthens India's technological independence.
                    </p>
                    <p style={{ fontSize: "0.9rem", lineHeight: 1.65, marginTop: "1rem" }}>
                        We aim to create platforms powered by advanced AI that safeguard data, empower citizens, and enable individuals and businesses to communicate, create, transact, and thrive—without relying on foreign-controlled digital infrastructures.
                    </p>
                    <p style={{ fontSize: "0.9rem", lineHeight: 1.65, marginTop: "1rem" }}>
                        Algebracorp is committed to delivering solutions that are <strong>Made in India, built for the world</strong>, ensuring that critical digital capabilities remain within the nation's control. Through innovation, scale, and deep AI integration, we strive to contribute meaningfully to India's journey toward digital self-reliance and global leadership in technology.
                    </p>
                </div>
            </div>
        </div><footer
            style={{
                padding: "2rem 1.5rem",
                textAlign: "center",
                background: "#fff",
                marginTop: "1rem",
                borderTop: "1px solid #e0e0e0",
            }}
        >
                {/* COMPANY */}
                <p style={{ margin: "0 0 0.6rem 0", fontWeight: 600 }}>
                    © 2025 Algebracorp OPC Private Limited
                </p>

                {/* ADDRESS */}
                <p style={{ margin: "0 0 1.2rem 0", fontSize: "0.9rem", color: "#555" }}>
                    Office Address: 16th Park View, Gaur Yamuna City Greater Noida. Up
                </p>

                {/* SOCIAL ICONS */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1.4rem",
                        marginBottom: "1rem",
                    }}
                >
                    {/* WhatsApp */}
                    <a
                        href="https://wa.me/+917518410292"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="WhatsApp"
                        style={{ display: "inline-flex" }}
                    >
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                            alt="WhatsApp"
                            style={{
                                height: "28px",
                                width: "28px",
                                transition: "transform 0.25s ease",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
                            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")} />
                    </a>

                    {/* Instagram */}
                    <a
                        href="https://www.instagram.com/algebracorp"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                        style={{ display: "inline-flex" }}
                    >
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
                            alt="Instagram"
                            style={{
                                height: "28px",
                                width: "28px",
                                transition: "transform 0.25s ease",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.15)")}
                            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")} />
                    </a>
                </div>

                {/* TAGLINE */}
                <p style={{ margin: 0, fontSize: "0.85rem", color: "#777" }}>
                    Building India’s Next-Generation Digital & Commerce Ecosystems
                </p>
            </footer></>    
    );
};

export default AboutUs;



